import { defineMessage } from 'react-intl';

export const walletSizeLimitHintMessage = defineMessage({
  id: 'wallet:size-limit-hint:message',
  defaultMessage: 'You may add up to {sizeLimit} payment {sizeLimit, plural, one {method} other {methods}}.',
  description: 'Wallet size limit description',
});
